import EditLimitOrderComponent from 'common/components/EditLimitOrder/EditLimitOrder.component';

import './index.css';

export type EditLimitOrderPopupProps = {
  title: string;
  orderId: number;
  price?: number;
  onCancel?: () => void;
};

const EditLimitOrderPopup = ({ orderId, price, onCancel }: EditLimitOrderPopupProps) => (
  <div className='edit-limit-order'>
    <EditLimitOrderComponent orderId={orderId.toString()} price={price} onCancel={onCancel} />
  </div>
);

export default (props: EditLimitOrderPopupProps) => ({
  component: <EditLimitOrderPopup {...props} />,
  hideCloseIcon: false,
  title: props.title,
  closeOnClickOutside: false,
  onCloseHandler: () => {
    props.onCancel?.();
  },
});
